var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-container biometric-await flex flex--column flex--start"},[_c('h1',[_vm._v("זיהוי ביומטרי")]),_c('img',{attrs:{"src":_vm.biometricIconPath,"alt":"biometric icon"}}),_c('h3',[_vm._v("כבר מתחברים...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }